import React, { useContext, useEffect, useState } from "react";
import { Col, Row, Form, Input, message, Card, Select, Button, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import "dayjs/locale/en";
import { UploadFile } from "antd/lib/upload";
import Upload from "antd/es/upload";
import { BiSolidInbox, BiUpload } from "react-icons/bi";
import { MdDeleteOutline } from "react-icons/md";
import { AuthContext } from "../../Auth/AuthContext";
import { useParams } from "react-router-dom";
import { getAllrole, getRoleByID, updateRole } from "../../utils/API";
import { ArrowLeftOutlined } from "@ant-design/icons";

interface EditCustomersModalProps {
  visible: boolean;
  taskId?: string;
  customerId?: string;
  onClose?: () => void;
  onEdit?: () => void;
  onCancel?: () => void;
  onSuccess?: () => void; // Changed from any to void
}

const EditRole: React.FC<EditCustomersModalProps> = ({
  visible,
  onClose,
  onSuccess,
  customerId,
}) => {
  const navigate = useNavigate();
  const { Option } = Select;
  const { authData } = useContext(AuthContext);
  const [form] = Form.useForm(); // Use Form hook to get form instance
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const roleId = authData.roleId;
  const fetchRoles = async () => {
    if (!customerId) {
      console.error("Error: Role ID is undefined");
      message.error("Invalid Role ID.");
      return;
    }

    setLoading(true);
    try {
      const roleData = await getRoleByID(customerId);
      // console.log("Fetched Role Data:", roleData);

      if (roleData) {
        form.setFieldsValue({
          name: roleData.name, // ✅ Ensure correct field name
          roleId: roleData.roleId
        });
      }
    } catch (error) {
      console.error("Error fetching role:", error);
      message.error("Failed to fetch role data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (customerId) {
      fetchRoles();
    }
  }, [customerId]);

  const handleSubmit = async (values: any) => {
    // console.log("Updating role for ID:", id);
    if (!customerId) {
      message.error("Role ID is missing!");
      return;
    }

    setIsSaving(true);
    try {
      const updatedData = {
        name: values.name, // ✅ Ensure correct field mapping
        roleId: values.roleId
      };

      // console.log("Submitting Data:", updatedData);

      await updateRole(customerId, updatedData); // ✅ Send correct data format
      message.success("Role updated successfully!");
      if (onClose) {
        onClose();
      }
      if (onSuccess) onSuccess();
      // navigate("/roles"); // ✅ Redirect after successful update
    } catch (error) {
      console.error("Error updating role:", error);
      message.error("Failed to update role.");
    } finally {
      setIsSaving(false);
    }
  };



  return (
    <Modal

      visible={visible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered={false} // Disable centered to use top positioning
      destroyOnClose
      className="custom-modal"
      style={{
        bottom: 20,
        top: 20,
        maxHeight: 'calc(100vh - 3  0px)', // Leaves 20px space at bottom
        margin: '0 auto',
        position: 'relative',
        // paddingBottom: 20 // Adds space inside modal at bottom
      }}
      bodyStyle={{
        // maxHeight: 'calc(90vh - 55px)',
        overflowY: 'auto',
        // padding: '20px',
        fontFamily: "inter, sans-serif",
      }}
      styles={{
        header: {
          padding: "12px",
          position: "sticky",
          top: 0,
          backgroundColor: "#f1f5ffff",
        },
        content: {
          padding: 0,
          overflow: "hidden",
        },
      }}
      title={
        <div
          style={{
            color: "#4b5563",
            fontFamily: "inter, sans-serif",
            fontSize: "20px",
            fontWeight: 500,
          }}
        >
          Edit Role
        </div>
      }
    >
      <Form
        onFinish={handleSubmit}
        form={form}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        colon={false}
        style={{ margin: 0 }}
      >

        <div className="elements">
          {/* Role Input */}

          <Form.Item
            name="name"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Role<span className="text-danger"> *</span></span>}
            rules={[{ required: true, message: "Please Enter Role" }]}
          >
            <Input
              size="large"
              disabled={Number(roleId) === 2}
              className="Allinput"
              placeholder="Enter Role"
            />
          </Form.Item>



          {/* Role ID Input */}
          <Form.Item
            name="roleId"
            required={false}
            label={<span style={{
              color: '#4b5563',
              fontFamily: 'inter, sans-serif',
              fontSize: '14px',
              paddingLeft: "15px",
              fontWeight: 500,
            }}>Role Id<span className="text-danger"> *</span></span>}
            rules={[{ required: true, message: "Please Enter Role ID" }]}
          >
            <Input
              size="large"
              disabled={Number(roleId) === 2}
              className="Allinput"
              placeholder="Enter Role ID"
            />
          </Form.Item>
        </div>
        

        {/* Submit Button */}
        <Row justify="end">
          <Col
            xs={24}
            sm={24}
            md={24}
            xl={24}
            xxl={20}
            className="d-flex justify-content-end me-3"
          >
            <div className="button-wrapper">
              <button
                className="allcanclebutton"
                onClick={onClose}
                type="button"
                disabled={isLoading}
              >
                Cancel
              </button>

              <button className="allsubmitebutton"
                type="submit"
                disabled={isLoading}>
                {isLoading ? "Updating Role..." : "Update Role"}
              </button>
            </div>
          </Col>
        </Row>

      </Form>
    </Modal >
  );
};

export default EditRole;